import React from 'react';
import CountyForm from "../../components/PagesForm/CountyForm";

function CountyAdd() {
    return (
        <CountyForm isEdit={false} />
    );
}

export default CountyAdd;